export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()
  const authDataStore = useAuthDataStore()
  const localePath = useLocalePath()
  const { hasEntityAccess } = useAuth()

  if (authStore.token && !authDataStore.userData) {
    await authStore.me()
  }

  // Check if entity (user/bar/firm) has access using entity-aware status check
  const entityStatus = authDataStore.entityStatus
  if (hasEntityAccess(entityStatus) === false) {
    return navigateTo({
      path: localePath({ name: 'auth-access-denied' })
    })
  }
})
